import { forwardRef, type AnchorHTMLAttributes } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router";

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; replace?: boolean; prefetch?: boolean };

function isExternal(href: string): boolean {
  return /^[a-z]+:/i.test(href) || href.startsWith("//");
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ href, replace, prefetch, download, ...rest }, ref) {
  void prefetch;
  if (isExternal(href) || download !== undefined) {
    return <a ref={ref} href={href} download={download} {...rest} />;
  }
  return <RouterLink ref={ref} to={href} replace={replace} {...rest} />;
});

export function usePathname(): string {
  return useLocation().pathname;
}

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
  };
}
